import type { ActionType } from 'typesafe-actions'
import type * as actions from './actions'
import { ActionTypes } from './constants'
import type { MaterialsState } from './types'

const initState: MaterialsState = {
  groups: [],
  materials: [],
  projectMaterials: [],
  materialAssemblies: [],
  projectMaterialAssemblies: [],
  materialPricing: [],
  crews: [],
}

const materials = (state = initState, action: ActionType<typeof actions>): MaterialsState => {
  switch (action.type) {
    case ActionTypes.GET_MATERIAL_PRICING:
      return {
        ...state,
        materialPricing: action.payload.materialPricing,
      }

    case ActionTypes.MATERIAL_PRICING_ADDED:
      // ✅ For ADDED - expects single object
      const newPricing = action.payload.materialPricing
      const currentPricing = Array.isArray(state.materialPricing) ? state.materialPricing : []

      return {
        ...state,
        materialPricing: [newPricing, ...currentPricing],
      }

    case ActionTypes.GET_MATERIAL_ASSEMBLIES:
      return {
        ...state,
        materialAssemblies: action.payload.materialAssemblies,
      }

    case ActionTypes.GET_PROJECT_MATERIAL_ASSEMBLIES:
      return {
        ...state,
        projectMaterialAssemblies: action.payload.projectMaterialAssemblies,
      }
    case ActionTypes.GET_MATERIALS_GROUPS: {
      return {
        ...state,
        groups: action.payload.groups,
      }
    }
    case ActionTypes.POST_MATERIALS_GROUP:
      return {
        ...state,
        groups: [...state.groups, action.payload.group],
      }
    case ActionTypes.EDIT_MATERIALS_GROUP:
      return {
        ...state,
        groups: state.groups.map((group) => {
          if (group.id === action.payload.group.id) {
            return {
              ...action.payload.group,
            }
          }
          return group
        }),
      }
    case ActionTypes.GET_MATERIALS:
      return {
        ...state,
        materials: action.payload.materials,
      }

    case ActionTypes.EDIT_MATERIAL:
      return {
        ...state,
        materials: state.materials.map((group) => {
          if (group.id === action.payload.material.id) {
            return action.payload.material
          }
          return group
        }),
      }

    case ActionTypes.POST_MATERIAL:
      return {
        ...state,
        materials: [action.payload.material, ...state.materials],
      }

    case ActionTypes.DELETE_MATERIAL:
      return {
        ...state,
        materials: state.materials.filter((material) => material.id !== action.payload.materialId),
      }

    case ActionTypes.GET_MATERIAL_GROUPS:
      return {
        ...state,
        materials: state.materials.map((material) => {
          if (material.id === action.payload.materialId) {
            return {
              ...material,
              groups: state.groups.filter((group) => group.materialIds?.includes(action.payload.materialId)),
            }
          }

          return material
        }),
      }

    case ActionTypes.GET_PROJECT_MATERIALS:
      return {
        ...state,
        projectMaterials: action.payload.materials,
      }

    case ActionTypes.DELETE_PROJECT_MATERIAL:
      return {
        ...state,
        projectMaterials: state.projectMaterials.filter((material) => material.id !== action.payload.materialId),
      }

    case ActionTypes.GET_PROJECT_TAKEOFF_QUANTITIES:
      return {
        ...state,
        takeoffQuantities: action.payload.takeoffQuantities,
      }

    case ActionTypes.GET_MATERIAL_PRICINGS:
      return {
        ...state,
        materialPricings: action.payload.materialPricings,
      }

    case ActionTypes.POST_MATERIAL_PRICING:
      return {
        ...state,
        materialPricings: [...state.materialPricings, action.payload.materialPricing],
      }

    case ActionTypes.EDIT_MATERIAL_PRICING:
      return {
        ...state,
        materialPricing: state.materialPricing.map((pricing) => {
          if (pricing.id === action.payload.materialPricing.id) {
            return action.payload.materialPricing
          }
          return pricing
        }),
      }

    case ActionTypes.DELETE_MATERIAL_PRICING:
      return {
        ...state,
        materialPricing: state.materialPricing.filter((pricing) => pricing.id !== action.payload.materialPricingId),
      }

    case ActionTypes.GET_CREWS:
      return {
        ...state,
        crews: action.payload.crews,
      }

    case ActionTypes.POST_CREW:
      return {
        ...state,
        crews: [action.payload.crew, ...state.crews],
      }

    case ActionTypes.EDIT_CREW:
      return {
        ...state,
        crews: state.crews.map((c) => (c.id === action.payload.crew.id ? action.payload.crew : c)),
      }

    case ActionTypes.DELETE_CREW:
      return {
        ...state,
        crews: state.crews.filter((c) => c.id !== action.payload.crewId),
      }

    default:
      return state
  }
}

export default materials
